/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DressingsViewerAliases {
  ACTION_CANCEL_DRESSING = 'action-cancel-dressing',
  ACTION_INACTIVATE_DRESSING = 'action-inactivate-dressing',
  ACTION_RELEASE_DRESSING = 'action-release-dressing',
  CONTEXTUAL_BAR_DRESSINGS_VIEWER = 'contextual-bar-dressings-viewer',
  FIELD_DRESSING_AMOUNT_NECROTIC_TISSUE = 'field-dressing-amount-necrotic-tissue',
  FIELD_DRESSING_DEAD_SPACE = 'field-dressing-dead-space',
  FIELD_DRESSING_DEGREE_OR_STAGE = 'field-dressing-degree-or-stage',
  FIELD_DRESSING_DEPTH = 'field-dressing-depth',
  FIELD_DRESSING_DEPTH_CM = 'field-dressing-depth-cm',
  FIELD_DRESSING_DRESCRIPTION_RESULT = 'field-dressing-drescription-result',
  FIELD_DRESSING_EPITHELIALIZATION = 'field-dressing-epithelialization',
  FIELD_DRESSING_EXUDATE_AMOUNT = 'field-dressing-exudate-amount',
  FIELD_DRESSING_GANGRENE = 'field-dressing-gangrene',
  FIELD_DRESSING_GRANULATION_TISSUE = 'field-dressing-granulation-tissue',
  FIELD_DRESSING_HARDENING_OF_PERIPHERAL_TISSUE = 'field-dressing-hardening-of-peripheral-tissue',
  FIELD_DRESSING_LENGTH_CM = 'field-dressing-length-cm',
  FIELD_DRESSING_MACERATION = 'field-dressing-maceration',
  FIELD_DRESSING_NOTE = 'field-dressing-note',
  FIELD_DRESSING_PAIN_AROUND = 'field-dressing-pain-around',
  FIELD_DRESSING_PERIPHERAL_TISSUE_EDEMA = 'field-dressing-peripheral-tissue-edema',
  FIELD_DRESSING_PRIORITY = 'field-dressing-priority',
  FIELD_DRESSING_RESULT = 'field-dressing-result',
  FIELD_DRESSING_SIZE = 'field-dressing-size',
  FIELD_DRESSING_SKIN_COLOR_AROUND_WOUND = 'field-dressing-skin-color-around-wound',
  FIELD_DRESSING_TIME_MIN = 'field-dressing-time-min',
  FIELD_DRESSING_TOTAL_SCORE = 'field-dressing-total-score',
  FIELD_DRESSING_TYPE_NECROTIC_TISSUE = 'field-dressing-type-necrotic-tissue',
  FIELD_DRESSING_TYPE_OF_EXUDATE = 'field-dressing-type-of-exudate',
  FIELD_DRESSING_VALIDITY_HOURS = 'field-dressing-validity-hours',
  FIELD_DRESSING_WIDTH_CM = 'field-dressing-width-cm',
  FIELD_ENCOUNTER = 'field-encounter',
  FIELD_RECORD_DATE = 'field-record-date',
  FIELD_RELEASE_DATE = 'field-release-date',
  FIELD_SECTOR = 'field-sector',
  FORM_DRESSINGS_VIEWER = 'form-dressings-viewer',
  FRAGMENT_REFERENCE_PATIENT_BAR = 'fragment-reference-patient-bar',
  LAYOUT_DRESSINGS_VIEWER = 'layout-dressings-viewer',
  PANEL_PATIENT_BAR = 'panel-patient-bar',
  TEXT_AREA_DRESSING_DRESCRIPTION_RESULT = 'text-area-dressing-drescription-result',
  TEXT_AREA_DRESSING_NOTE = 'text-area-dressing-note',
  TEXT_DRESSING_AMOUNT_NECROTIC_TISSUE = 'text-dressing-amount-necrotic-tissue',
  TEXT_DRESSING_DEAD_SPACE = 'text-dressing-dead-space',
  TEXT_DRESSING_DEGREE_OR_STAGE = 'text-dressing-degree-or-stage',
  TEXT_DRESSING_DEPTH = 'text-dressing-depth',
  TEXT_DRESSING_DEPTH_CM = 'text-dressing-depth-cm',
  TEXT_DRESSING_EPITHELIALIZATION = 'text-dressing-epithelialization',
  TEXT_DRESSING_EXUDATE_AMOUNT = 'text-dressing-exudate-amount',
  TEXT_DRESSING_GANGRENE = 'text-dressing-gangrene',
  TEXT_DRESSING_GRANULATION_TISSUE = 'text-dressing-granulation-tissue',
  TEXT_DRESSING_HARDENING_OF_PERIPHERAL_TISSUE = 'text-dressing-hardening-of-peripheral-tissue',
  TEXT_DRESSING_LENGTH_CM = 'text-dressing-length-cm',
  TEXT_DRESSING_MACERATION = 'text-dressing-maceration',
  TEXT_DRESSING_PAIN_AROUND = 'text-dressing-pain-around',
  TEXT_DRESSING_PERIPHERAL_TISSUE_EDEMA = 'text-dressing-peripheral-tissue-edema',
  TEXT_DRESSING_PRIORITY = 'text-dressing-priority',
  TEXT_DRESSING_RESULT = 'text-dressing-result',
  TEXT_DRESSING_SIZE = 'text-dressing-size',
  TEXT_DRESSING_SKIN_COLOR_AROUND_WOUND = 'text-dressing-skin-color-around-wound',
  TEXT_DRESSING_TIME_MIN = 'text-dressing-time-min',
  TEXT_DRESSING_TOTAL_SCORE = 'text-dressing-total-score',
  TEXT_DRESSING_TYPE_NECROTIC_TISSUE = 'text-dressing-type-necrotic-tissue',
  TEXT_DRESSING_TYPE_OF_EXUDATE = 'text-dressing-type-of-exudate',
  TEXT_DRESSING_VALIDITY_HOURS = 'text-dressing-validity-hours',
  TEXT_DRESSING_WIDTH_CM = 'text-dressing-width-cm',
  TEXT_ENCOUNTER = 'text-encounter',
  TEXT_RECORD_DATE = 'text-record-date',
  TEXT_RELEASE_DATE = 'text-release-date',
  TEXT_SECTOR = 'text-sector',
}
export { DressingsViewerAliases };
